const BrazilSvg = () => (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_4152_110948)">
      <path
        d="M20 40C31.0457 40 40 31.0457 40 20C40 8.9543 31.0457 0 20 0C8.9543 0 0 8.9543 0 20C0 31.0457 8.9543 40 20 40Z"
        fill="#6DA544"
      />
      <path
        d="M20.0002 7.82715L36.522 20.0011L20.0002 32.175L3.47852 20.0011L20.0002 7.82715Z"
        fill="#FFDA44"
      />
      <path
        d="M19.9999 26.9559C23.8419 26.9559 26.9564 23.8414 26.9564 19.9995C26.9564 16.1575 23.8419 13.043 19.9999 13.043C16.158 13.043 13.0435 16.1575 13.0435 19.9995C13.0435 23.8414 16.158 26.9559 19.9999 26.9559Z"
        fill="#F0F0F0"
      />
      <path
        d="M16.5219 19.5654C15.3122 19.5654 14.1448 19.7494 13.0459 20.0908C13.0946 23.8908 16.1886 26.9568 20.0002 26.9568C22.3571 26.9568 24.4386 25.7836 25.697 23.9905C23.5441 21.2954 20.2315 19.5654 16.5219 19.5654Z"
        fill="#0052B4"
      />
      <path
        d="M26.8281 21.3323C26.9118 20.9007 26.9571 20.4555 26.9571 19.9995C26.9571 16.1574 23.8425 13.043 20.0006 13.043C17.1338 13.043 14.6729 14.7774 13.6079 17.2538C14.5493 17.0587 15.524 16.956 16.5224 16.956C20.5628 16.9559 24.2179 18.6355 26.8281 21.3323Z"
        fill="#0052B4"
      />
    </g>
    <defs>
      <clipPath id="clip0_4152_110948">
        <rect width="40" height="40" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export default BrazilSvg;
